"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProviderTaxonomyCode_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ProviderTaxonomyCode_Factory = /** @class */ (function () {
    function ProviderTaxonomyCode_Factory() {
    }
    ProviderTaxonomyCode_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ProviderTaxonomyCategory: model.ProviderTaxonomyCategory,
            ProviderTaxonomyCode1: model.ProviderTaxonomyCode1,
        };
        return result;
    };
    ProviderTaxonomyCode_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ProviderTaxonomyCategory: model.ProviderTaxonomyCategory,
            ProviderTaxonomyCode1: model.ProviderTaxonomyCode1,
        };
        return result;
    };
    return ProviderTaxonomyCode_Factory;
}());
exports.ProviderTaxonomyCode_Factory = ProviderTaxonomyCode_Factory;
